<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations demande résiliation</div>
  <div cardRows class="card__rows w-100">
    <div class="flex-basis-100">
      <div
        class="card__row"
        *ngIf="metadata.policyProposalId || originalMetadata?.policyProposalId"
      >
        <span class="card__label" i18n>Police à résilier</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.policyProposalId !== metadata.policyProposalId,
            }"
          >
            <a [href]="policyLink" id="proposalLink">{{
              proposalDetails?.policyDetails?.policyId
            }}</a>
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyProposalId &&
              originalMetadata.policyProposalId !== metadata.policyProposalId
            "
          >
            {{ originalMetadata.policyProposalId }}
          </span>
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata.insuranceToCancel || originalMetadata?.insuranceToCancel
        "
      >
        <span class="card__label" i18n>Type d'assurance à résilier</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.insuranceToCancel !==
                  metadata.insuranceToCancel,
            }"
            >{{ getInsuranceTypeLabel(metadata.insuranceToCancel) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.insuranceToCancel &&
              originalMetadata.insuranceToCancel !== metadata.insuranceToCancel
            "
            >{{
              getInsuranceTypeLabel(originalMetadata.insuranceToCancel)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata.transmissionMethod || originalMetadata?.transmissionMethod
        "
      >
        <span class="card__label" i18n>Méthode d'envoi</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.transmissionMethod !==
                  metadata.transmissionMethod,
            }"
            >{{ getTransmissionMethodLabel(metadata.transmissionMethod) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.transmissionMethod &&
              originalMetadata.transmissionMethod !==
                metadata.transmissionMethod
            "
            >{{
              getTransmissionMethodLabel(originalMetadata.transmissionMethod)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata.cancellationLetterKey &&
          metadata.cancellationLetterKey.length > 0
        "
      >
        <span class="card__label" i18n>Lettres de résiliation</span>
        <div class="card__value d-flex flex-wrap justify-content-between">
          <div
            class="uploaded-file-container flex-basis-50"
            *ngFor="let doc of metadata.cancellationLetterKey; let i = index"
            (click)="viewFile(doc)"
          >
            <div class="uploaded-file-element clickable">
              <app-file-icon
                height="20px"
                width="20px"
                color="var(--gray-400)"
              />
              <div class="file-name">
                <span
                  ><ng-container i18n>Lettre </ng-container>{{ i + 1 }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card__row" *ngIf="metadata.insuranceDocumentKeys">
        <span class="card__label" i18n>Documents d'assurance</span>
        <div class="card__value d-flex flex-wrap justify-content-between">
          <div
            class="uploaded-file-container flex-basis-50"
            *ngFor="let doc of metadata.insuranceDocumentKeys; let i = index"
            (click)="viewFile(doc)"
          >
            <div class="uploaded-file-element clickable">
              <app-file-icon
                height="20px"
                width="20px"
                color="var(--gray-400)"
              />
              <div class="file-name">
                <span
                  ><ng-container i18n>Fichier </ng-container>{{ i + 1 }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-card>
<app-pdf-viewer-modal #pdfViewer />
